import { render } from "./BreaksGanttPage.vue?vue&type=template&id=163be066"
import script from "./BreaksGanttPage.vue?vue&type=script&lang=js"
export * from "./BreaksGanttPage.vue?vue&type=script&lang=js"

import "./BreaksGanttPage.vue?vue&type=style&index=0&id=163be066&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__